import { useEffect } from "react";

/** Dedupe traces within the same JS task (e.g. React Strict Mode double effect). */
let _traceDedupeSig = null;

function buildOrgTourInfoDevTraceSignature(display, contentHtmlSanitized, contentText) {
  const h = typeof contentHtmlSanitized === "string" ? contentHtmlSanitized : "";
  const t = typeof contentText === "string" ? contentText : "";
  const probe = (h || t).slice(0, 160);
  return [
    display?.mode ?? "",
    display?.blockedRaw ? "1" : "0",
    display?.html?.length ?? 0,
    display?.text?.length ?? 0,
    probe,
  ].join("\u0001");
}

/**
 * DEV-only: logs one sanitized/text trace per distinct payload per task.
 * Identical modular + legacy mounts in the same tick share one trace line.
 */
export function useOrgTourInfoDevDisplayTrace(display, contentHtmlSanitized, contentText) {
  useEffect(() => {
    if (!import.meta.env?.DEV) return;

    console.log("[ORG_TOUR_INFO_FE_RENDER_TRACE]", {
      hasContentText: Boolean(contentText && String(contentText).trim()),
      hasContentHtmlSanitized: Boolean(contentHtmlSanitized && String(contentHtmlSanitized).trim()),
      displayMode: display.mode,
      fallbackReason: display.fallbackReason ?? null,
    });

    const sig = buildOrgTourInfoDevTraceSignature(display, contentHtmlSanitized, contentText);
    if (_traceDedupeSig === sig) return;
    _traceDedupeSig = sig;
    const clearSig = sig;
    queueMicrotask(() => {
      if (_traceDedupeSig === clearSig) {
        _traceDedupeSig = null;
      }
    });

    if (display.blockedRaw) {
      console.warn("[ORG_TOUR_INFO_RAW_CONTENT_BLOCKED]", {
        hadHtml: Boolean(contentHtmlSanitized),
        hadText: Boolean(contentText),
      });
    }
    if (display.mode === "html") {
      console.log("[ORG_TOUR_INFO_RENDER_SANITIZED]", {
        htmlLen: display.html?.length ?? 0,
      });
    } else if (display.mode === "text") {
      console.log("[ORG_TOUR_INFO_RENDER_TEXT_FALLBACK]", {
        textLen: display.text?.length ?? 0,
      });
    }
  }, [display, contentHtmlSanitized, contentText]);
}
